module.exports = __webpack_public_path__ + "img/drone_03_H.22ee3b9d.webp";